import TargetScore from "./TargetScore";
import "./target-score.scss";

export default TargetScore;
